/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Status_InitializingInputs */



/**
* | output |
* | --- |
* | "Initializing..." |
*
* @param {Iframe_Remote_Status_InitializingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_status_initializing = /** @type {((inputs?: Iframe_Remote_Status_InitializingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Status_InitializingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Initialisation...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Initialisierung läuft...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizializzazione in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Инициализация...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicializando...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在初始化...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("初期化中...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आरंभ हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inicializando...")
	return /** @type {LocalizedString} */ ("Initializing...")
});